import { NgModule } from '@angular/core';
import { quotesPaths, quotesDefaultAuth } from './quotes.routes';
import { RouterModule, Routes } from '@angular/router';
import { QuoteListModule } from './quote-list/quote-list.module';
import { QuoteDetailModule } from './quote-detail/quote-detail.module';
import { QuoteListComponent } from './quote-list/quote-list.component';
import { QuoteDetailComponent } from './quote-detail/quote-detail.component';

const routes: Routes = [
	{
		path: quotesPaths.default,
		pathMatch: 'prefix',
		component: QuoteListComponent,
		...quotesDefaultAuth,
	},
	{
		path: quotesPaths.list,
		pathMatch: 'prefix',
		component: QuoteListComponent,
		...quotesDefaultAuth,
	},
	{
		path: quotesPaths.detail,
		pathMatch: 'prefix',
		component: QuoteDetailComponent,
		...quotesDefaultAuth,
	},
];

@NgModule({
	imports: [
		RouterModule.forChild(routes),
		QuoteListModule,
		QuoteDetailModule,
	],
})
export class QuotesModule {}
